import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./select";

const fontOptions = [
  { label: "Inter", value: "Inter" },
  { label: "Roboto", value: "Roboto" },
  { label: "Montserrat", value: "Montserrat" },
];

export function SelectTipografia({
  value,
  onChange,
}: {
  value: string;
  onChange: (font: string) => void;
}) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger>
        <SelectValue placeholder="Selecciona una tipografía" />
      </SelectTrigger>
      <SelectContent>
        {fontOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            <span style={{ fontFamily: `var(--font-${option.value})` }}>
              {option.label}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
